import React from 'react';
import { Link, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

const PromotionHeader = ({
  liveEnabled,
  showEnabled,
  mapsEnabled,
  configuratorEnabled,
  digitalShowUrl,
}) => {
  const {
    clientId,
    promotionId,
  } = useParams();
  return (
    <div className="promotion-header">
      <div className="container-available-content">
        <div className="available-content">
          <div className="title">
            <div className="title-text">contenido publicado</div>
            <div className="title-icon" />
          </div>
          <div className="subtitle">Gestión de contenido final</div>
          <div className="description">Espacio donde se encuentra todo el material validado de “mis entregas” listo para
            ser usado, descargado y publicado.
          </div>
          <Link to={`/client/${clientId}/${promotionId}/live`} className={`link-live${liveEnabled ? '' : ' disabled'}`}>
            <div className={`live-button${liveEnabled ? '' : ' disabled'}`}><span>Entrar</span></div>
          </Link>
        </div>
      </div>
      <div className="container-digital-show">
        {mapsEnabled && (
          <div className="digital-maps">
            <div className="logo" />
            <div className="description">Accede para visualizar todo el contenido publicado en la experiencia web ALL
              in ONE
            </div>
            <button
              type="button"
              onClick={() => window.open(digitalShowUrl, '_blank')}
              className="live-button"
              aria-label="DigitalSHOW"
            >
              <span>Acceso GESTOR</span>
            </button>
            <button
              type="button"
              onClick={() => window.open(digitalShowUrl, '_blank')}
              className={`live-button${showEnabled ? '' : ' disabled'}`}
              aria-label="DigitalSHOW"
            >
              <span>Abrir</span>
            </button>
          </div>
        )}
        {configuratorEnabled && (
          <div className="digital-configurator">
            <div className="logo" />
            <div className="description">Accede para visualizar todo el contenido publicado en la experiencia web ALL
              in ONE
            </div>
            <button
              type="button"
              onClick={() => window.open(digitalShowUrl, '_blank')}
              className="live-button"
              aria-label="DigitalSHOW"
            >
              <span>Acceso GESTOR</span>
            </button>
            <button
              type="button"
              onClick={() => window.open(digitalShowUrl, '_blank')}
              className={`live-button${liveEnabled ? '' : ' disabled'}`}
              aria-label="DigitalSHOW"
            >
              <span>Abrir</span>
            </button>
          </div>
        )}
        <div className="digital-show">
          <div className="logo" />
          <div className="description">Accede para visualizar todo el contenido publicado en la experiencia web ALL
            in ONE
          </div>
          <button
            type="button"
            onClick={() => window.open(digitalShowUrl, '_blank')}
            className={`live-button${showEnabled ? '' : ' disabled'}`}
            aria-label="DigitalSHOW"
          >
            <span>Abrir</span>
          </button>
        </div>
      </div>
    </div>
  );
};

PromotionHeader.propTypes = {
  liveEnabled: PropTypes.bool.isRequired,
  showEnabled: PropTypes.bool.isRequired,
  mapsEnabled: PropTypes.bool.isRequired,
  configuratorEnabled: PropTypes.bool.isRequired,
  digitalShowUrl: PropTypes.string.isRequired,
};

export default PromotionHeader;
